import { createRouter, createWebHistory } from "vue-router";
import { useAuthStore } from "@/stores/auth";
import { useDeviceVerifierStore } from '@/stores/deviceVerifier';

import LoginPage from "@/views/loginPage.vue";
import OrderPage from "@/views/orderPage.vue";
import ReportPage from "@/views/reportPage.vue";
import SettingsPage from "@/views/settingsPage.vue";
import ReceiptPage from "@/views/receiptPage.vue";

const routes = [
  {
    path: "/",
    name: "OrderPage",
    component: OrderPage,
  },
  {
    path: "/receipt",
    name: "ReceiptPage",
    component: ReceiptPage,
  },
  {
    path: "/report",
    name: "ReportPage",
    component: ReportPage,
  },
  {
    path: "/settings",
    name: "SettingsPage",
    component: SettingsPage,
  },
  {
    path: "/login",
    name: "LoginPage",
    component: LoginPage,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

router.beforeEach((to, from, next) => {
  const authStore = useAuthStore();
  if (!authStore.isAuthenticated() && to.path !== "/login") {
    console.log("Access Denied! Redirecting to login...");
    return next("/login");
  } else {
    if (to.path !== "/login") {
      const deviceStore = useDeviceVerifierStore();
      const { uuid, isVerified } = deviceStore;
      const isInvalid =
        !uuid || uuid.trim() === '' || !isVerified;
  
      if (isInvalid) {
        deviceStore.openPosVerifierModal(); // trigger modal
        if (to.path !== "/") {
          return next("/");
        }
      }
    }
    next();
  }
});

export default router;
